import angular from "angular";

import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";

import AppOverlayService from "./AppOverlayService";
import AppOverlayController from "./AppOverlayController";

const AppOverlayComponent = {
    name: "tbAppOverlay",
    config: {
        template: AppOverlayController.template,
        bindings: {},
        controller: AppOverlayController,
        controllerAs: AppOverlayController.controllerAs
    }
};

export default angular
    .module("trackerbase-app.directives.app-overlay", DependencyListBuilder([
        AppOverlayService.dependencies,
        AppOverlayController.dependencies
    ]))
    .service("AppOverlay", AppOverlayService)
    .component(AppOverlayComponent.name, AppOverlayComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/directives/app-overlay/index.js
// module id = 6Zo4
// module chunks = 1